<template>
    <transition name="modal">
        <div
            v-if="show"
            class="modal-overlay"
            @click="$emit('close')"
        >
            <div class="modal-content" @click.stop>
                <div class="modal-header">
                    <h3>Reset Settings?</h3>
                </div>
                <div class="modal-body">
                    <p>
                        Are you sure you want to reset all settings to their
                        default values? This action cannot be undone.
                    </p>
                </div>
                <div class="modal-actions">
                    <button
                        @click="$emit('close')"
                        class="cancel-btn"
                    >
                        Cancel
                    </button>
                    <button @click="$emit('confirm')" class="confirm-btn">
                        Reset Settings
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'ResetConfirmModal',
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close', 'confirm']
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
}

.modal-content {
    background: var(--bg-secondary);
    border: 1px solid var(--accent);
    border-radius: 8px;
    max-width: 500px;
    width: 100%;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);
}

.modal-header {
    padding: 20px 30px;
    border-bottom: 1px solid var(--accent);
}

.modal-header h3 {
    margin: 0;
    color: var(--text-secondary);
    font-size: 24px;
}

.modal-body {
    padding: 30px;
}

.modal-body p {
    margin: 0;
    color: var(--text-primary);
    font-size: 16px;
    line-height: 1.6;
}

.modal-actions {
    padding: 20px 30px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    border-top: 1px solid var(--accent);
}

.cancel-btn {
    padding: 12px 24px;
    background: transparent;
    color: var(--text-primary);
    border: 1px solid var(--accent);
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 14px;
}

.cancel-btn:hover {
    background: var(--bg-secondary);
}

.confirm-btn {
    padding: 12px 24px;
    background: #ff6b6b;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 14px;
    font-weight: 600;
}

.confirm-btn:hover {
    background: #ff5252;
    transform: translateY(-2px);
    box-shadow: 0 5px 20px rgba(255, 68, 68, 0.4);
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
    opacity: 0;
}

.modal-enter-active .modal-content,
.modal-leave-active .modal-content {
    transition: transform 0.3s ease;
}

.modal-enter-from .modal-content {
    transform: scale(0.9);
}

.modal-leave-to .modal-content {
    transform: scale(0.9);
}

@media (max-width: 768px) {
    .modal-content {
        margin: 20px;
    }
}
</style>
